export default __webpack_public_path__ + "static/media/hospitality3.15184b7c.webp";